import { useCallback } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

export const useFlatInfoClick = () => {
  const { url } = useRouteMatch();
  const { push: historyPush } = useHistory();
  const { pathname, search } = useLocation();

  const onClick = useCallback(
    (flatId) => {
      const params = new URLSearchParams(search || '');
      params.set('scrollToFlatId', String(flatId));

      const fromPath =
        `${pathname}`.replace(/^\//, '') +
        `?${params.toString()}`;

      historyPush(`${url}/${flatId}`, { from: fromPath });
    },
    [historyPush, url, pathname, search]
  );

  return onClick;
};
